import {
  TargetPopulationData,
  TargetPopulationDataSchema,
} from '@aphp-ema/common/target-population';
import Papa from 'papaparse';

type ParseCSVResult = {
  fileName: string;
  data: TargetPopulationData;
};

export const parseCSV = (file: File): Promise<ParseCSVResult> => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const validationResult = TargetPopulationDataSchema.safeParse(
          results.data,
        );

        if (!validationResult.success) {
          reject('INVALID_CSV_DATA');
        } else {
          resolve({
            data: validationResult.data,
            fileName: file.name,
          });
        }
      },
      error: () => {
        reject('UNEXPECTED_ERROR');
      },
    });
  });
};
